import request from "superagent";
import { getErrorMessage } from "../../utils/errors";
import { getAuthHeader } from "../../utils/superagent";
import { isDefined } from "@clipboard-health/util-ts";
// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'error' implicitly has an 'any' type.
const handleError = (error) => ({
  body: {
    error: getErrorMessage(error),
  },
});

export const getUpcomingShiftsGrouped = async (workplaceId?: string) => {
  const queryParams = isDefined(workplaceId) ? { workplaceId } : {};
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .get(`${global.api}/v1/shifts/upcomingShiftsGrouped`)
      .set(await getAuthHeader())
      .query(queryParams)
      .then(({ body }) => body.response)
      .catch(handleError)
  );
};
